module.exports = __webpack_public_path__ + "img/@work_kiupIbk_list.5c946feb.jpg";